<template src="./VerEncuentrosExistentes.html"></template>
<script>
import moment from "moment";
import ListadoEncuentros from "../ListadoEncuentros/ListadoEncuentros";
import { serverBus } from "../../main";
import VerAcordeon from "../VerAcordeon/VerAcordeon";
import { formulariosLlenosPorTipoMomento } from "../../apiService/request/CrudEncuentro.js";
import metodos_comunes from "../../js/metodos_comunes";
import VerTarjetaMiniaturaExpansible from "../VerTarjetaMiniaturaExpansible/VerTarjetaMiniaturaExpansible";
import { consultarInformacionMomentosEncuentro } from "../../apiService/request/CrudEncuentro";
import Marcaciones from "../Marcaciones/Marcaciones";
import { consultarMarcacionesEncuentro } from "../../apiService/request/CrudEncuentro";
import { consultarTextoResumen } from "../../apiService/request/CrudEncuentro";
import SubirArchivo from "../SubirArchivo/SubirArchivo";
import Icono from "../Icono/Icono";
import { agregarNotaEncuentro } from "../../apiService/request/CrudEncuentro";

export default {
  data() {
    return {
      InformacionMomentosEncuentro: [],
      formulariosLlenosTipoMomentoAcordeon: [],
      informacionMarcaciones: [],
      notas: "",
      iconoFormulario:
        "M17,18c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H18C17.4,19,17,18.6,17,18z M30,23H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,23,30,23z M30,29H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,29,30,29z M30,35H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,35,30,35z M38,11l0,31c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h19c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2l10,10c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1C38,10.8,38,10.9,38,11C38,11,38,11,38,11z M28,10h6.6L28,3.4V10z M36,42l0-30h-9c-0.6,0-1-0.4-1-1V2H8l0,40L36,42z M14,17h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,17,14,17z M14,23h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,23,14,23z M14,29h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,29,14,29z M14,35h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,35,14,35z M44,0v44 M0,0v44",
      iconoDescargar:
        "M43,37.3H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1v-4.7C44,37.8,43.6,37.3,43,37.3z M42,42H2v-2.7h40V42zM10.8,23.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v30.3l8.8-8.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L22.7,34.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2L10.8,23.9z",
      iconoCargar:
        "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
      iconoCerrar:
        "M43.7,42.3c0.4,0.4,0.4,1,0,1.4C43.5,43.9,43.3,44,43,44s-0.5-0.1-0.7-0.3L22,23.4L1.7,43.7C1.5,43.9,1.3,44,1,44s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.6,22L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L22,20.6L42.3,0.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L23.4,22L43.7,42.3z",
      files: [],
      loading: false,
      fab: false,
      fileSelected: null,
      nuevaNota: "",
      cargandoArchivo: false,
      paciente: {}
    };
  },
  created() {
    this.consultarMomentosEncuentro(
      metodos_comunes.reemplazarCaracteresEspeciales(
        this.$store.getters.getConsultarEncuentroOverlay
      )
    );
    this.marcacionesEncuentro();
    this.textoResumen();
  },
  mounted() {
    this.paciente = {
      documento: this.$store.getters.getCedulaPaciente,
      nombre: this.$store.getters.getNombrePaciente
    };
    serverBus.$on("verCategoriaFormularioAcordeon3", formulario => {
      this.formulariosLlenosTipoMomentoAcordeon = [];
      this.$store.dispatch("setVariablesFormulariosOverlay", null);
      try {
        if (!this.$store.getters.getCargando) {
          this.$store.dispatch("setCargando", true);
        }
        this.consultarResumenEncuentrosPorTipoAcordeon(formulario);
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    });
    serverBus.$on("verEncuentroGestion3", nombreCategoria => {
      this.marcacionesEncuentro();
      this.textoResumen();
    });
  },
  beforeDestroy() {
    // serverBus.$off("abrirTarjetaFormulario");
    serverBus.$off("verCategoriaFormularioAcordeon3");
    serverBus.$off("verEncuentroGestion3");
  },
  filters: {
    moment: function(date, format) {
      var fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    }
  },
  computed: {
    getMomentoActual() {
      if (this.$store.getters.getMomentoActualOverlay != null) {
        this.formulariosLlenosTipoMomentoAcordeon = [];
      }
      return this.$store.getters.getMomentoActualOverlay;
    },
    getId() {
      if (this.$store.getters.getIdVerEncuentrosOSeguimiento != null) {
        this.InformacionMomentosEncuentro = [];
        this.consultarMomentosEncuentro(
          metodos_comunes.reemplazarCaracteresEspeciales(
            this.$store.getters.getConsultarEncuentroOverlay
          )
        );
        this.marcacionesEncuentro();
        this.textoResumen();
      }
      return this.$store.getters.getIdVerEncuentrosOSeguimiento;
    }
  },
  watch: {
  },
  methods: {
    async agregarNuevaNota() {
      this.$store.dispatch("setCargando", true);
      try {
        const respuesta = await agregarNotaEncuentro(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          this.nuevaNota,
          this.$store.state.provider_email,
          "encuentros"
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.nuevaNota = "";
        this.textoResumen();
      }
    },
    volver() {
      this.$store.dispatch("setIdVerEncuentrosOSeguimiento", null);
      this.InformacionMomentosEncuentro = [];
    },
    async consultarResumenEncuentrosPorTipoAcordeon(formulario) {
      try {
        const respuesta = await formulariosLlenosPorTipoMomento(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          "momento" + this.$store.getters.getMomentoActualOverlay,
          formulario.nombre
        );
        if (respuesta.data && respuesta.data.data) {
          this.formulariosLlenosTipoMomentoAcordeon = respuesta.data.data;
          for(let i = 0; i < this.formulariosLlenosTipoMomentoAcordeon.length; i++) {
            if (!this.formulariosLlenosTipoMomentoAcordeon[i].coleccion) {
              this.formulariosLlenosTipoMomentoAcordeon[i]["coleccion"] = formulario.coleccion;
            }
          }
        }
      } catch (err) {}
    },
    async consultarMomentosEncuentro(encuentro) {
      try {
        const respuesta = await consultarInformacionMomentosEncuentro(
          encuentro
        );
        this.InformacionMomentosEncuentro = respuesta.data.data;

        const id = this.$store.getters.getIdVerEncuentrosOSeguimiento;
        this.files = await descargarDocumento(id).then(res => res.data);
        this.$store.dispatch("setEncuentroOverlay", encuentro);
      } catch (err) {}
    },
    async marcacionesEncuentro() {
      try {
        const respuesta = await consultarMarcacionesEncuentro(
          this.$store.getters.getIdVerEncuentrosOSeguimiento
        );
        this.informacionMarcaciones = respuesta.data.data;
      } catch (err) {}
    },
    async textoResumen() {
      try {
        const respuesta = await consultarTextoResumen(
          this.$store.getters.getIdVerEncuentrosOSeguimiento,
          "encuentros"
        );
        this.notas = respuesta.data.data;
      } catch (err) {}
      finally {
      this.$store.dispatch("setCargando", false);
      }
    }
  },
  props: {
    cambio: Boolean
  },
  components: {
    ListadoEncuentros,
    VerAcordeon,
    VerTarjetaMiniaturaExpansible,
    Marcaciones,
    Icono,
    SubirArchivo
  }
};
</script>
<style src="./VerEncuentrosExistentes.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/VerEncuentrosExistentes/VerEncuentrosExistentes.vue